import React from "react";
import { Tile, TileBody, TileHeader } from "../../../../../common/components";
import styles from "./InfoBox.module.css";

const InfoBox = ({ actions, children, className, icon, title }) => (
	<Tile className={className}>
		<TileHeader className={styles.header} headerClassName={styles.header__header} iconName={icon} title={title}>
			{actions}
		</TileHeader>
		<TileBody className={styles.body}>{children}</TileBody>
	</Tile>
);

export default InfoBox;
